import IntroPartial from './IntroPartial';
import formatPrismicData from '../../hocs/formatPrismicData';

export default formatPrismicData(IntroPartial);



// WEBPACK FOOTER //
// ./src/client/js/view/components/IntroPartial/index.js